(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
document.addEventListener("DOMContentLoaded", function() {
    var darkModeToggle = document.querySelector("#toggleMode");
    var prefersDarkMode = window.matchMedia("(prefers-color-scheme:dark)").matches;
    var currentTheme = localStorage.getItem("theme");
    if (currentTheme === "dark" || currentTheme === null && prefersDarkMode) {
        document.querySelector("#toggleMode").checked = true;
        setDark();
    } else {
        document.querySelector("#toggleMode").checked = false;
        setLight();
    }
    darkModeToggle.addEventListener("change", function() {
        var currentTheme = localStorage.getItem("theme");
        currentTheme === "light" ? setDark() : setLight();
    });
    function setDark() {
        document.documentElement.classList.add("dark-theme");
        document.documentElement.classList.remove("light-theme");
        document.querySelector("#toggleMode").checked = true;
        document.documentElement.style.display = "block";
        localStorage.setItem("theme", "dark");
    }
    function setLight() {
        document.documentElement.classList.add("light-theme");
        document.documentElement.classList.remove("dark-theme");
        document.querySelector("#toggleMode").checked = false;
        document.documentElement.style.display = "block";
        localStorage.setItem("theme", "light");
    }
});


if (!window.direct) window.direct = {};
window.direct.getPosition = function(el, rel) {
    var x = 0, y = 0;
    do {
        x += (el === null || el === void 0 ? void 0 : el.offsetLeft) || 0;
        y += (el === null || el === void 0 ? void 0 : el.offsetTop) || 0;
        el = el === null || el === void 0 ? void 0 : el.offsetParent;
    }while (el && el !== rel);
    return {
        x: x,
        y: y
    };
};
window.direct.selectText = function(element) {
    if (document.body.createTextRange) {
        var range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        var selection = window.getSelection();
        var range1 = document.createRange();
        range1.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range1);
    }
};
window.direct.fetchAndUpdateCaptcha = function() {
    var captchaImages = document.querySelectorAll(".signup-captcha");
    var captchaTextFields = document.querySelectorAll(".captchaText");
    var keyFields = document.querySelectorAll(".key");
    fetch("/app/service/signup/captcha").then(function(response) {
        return response.json();
    }).then(function(data) {
        captchaImages.forEach(function(img) {
            img.setAttribute("src", data.imageData);
        });
        captchaTextFields.forEach(function(field) {
            field.value = data.captchaText;
        });
        keyFields.forEach(function(field) {
            field.value = data.key;
        });
    });
};
// Wrap an HTMLElement around another HTMLElement or an array of them.
HTMLElement.prototype.wrapAll = function(elms) {
    // Convert single element to array for consistent handling
    var elements = elms.length !== undefined ? elms : [
        elms
    ];
    var el = elements[0];
    // Cache the current parent and sibling of the first element.
    var parent = el.parentNode;
    var sibling = el.nextSibling;
    // Wrap the first element (is automatically removed from its
    // current parent).
    this.appendChild(el);
    // Wrap all other elements (if applicable). Each element is
    // automatically removed from its current parent.
    for(var i = 1; i < elements.length; i++)this.appendChild(elements[i]);
    // If the first element had a sibling, insert the wrapper before the
    // sibling to maintain the HTML structure; otherwise, just append it
    // to the parent.
    if (sibling) parent.insertBefore(this, sibling);
    else parent.appendChild(this);
};


document.addEventListener("DOMContentLoaded", function() {
    var backToTopLink = document.querySelector(".scroll-to-top");
    window.direct.showToTop = function() {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 300) backToTopLink.classList.add("show");
        else backToTopLink.classList.remove("show");
    };
    backToTopLink.addEventListener("click", function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    window.onscroll = function() {
        if (document.querySelector(".in-page-sub-nav")) {
            var scrollPosInPageNav = window.direct.getPosition(document.querySelector(".in-page-sub-nav"));
            if (scrollPosInPageNav.y === 0) document.querySelector(".in-page-sub-nav").classList.add("remove-radius");
            else document.querySelector(".in-page-sub-nav").classList.remove("remove-radius");
        }
        window.direct.showToTop();
    };
});


document.addEventListener("DOMContentLoaded", function() {
    window.scrollToElement = function(id) {
        var element = document.getElementById("".concat(id));
        if (element) {
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.scrollY - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
});


document.addEventListener("DOMContentLoaded", function() {
    new window.Vue({
        name: "searchBar",
        el: "#search-component",
        data: function data() {
            return {
                query: "",
                showSearch: false,
                searchResults: [],
                pages: [],
                noResults: false
            };
        },
        methods: {
            closeSearch: function closeSearch() {
                this.showSearch = false;
                document.querySelector("body").classList.remove("in-search");
                this.pages = [];
                this.searchResults = [];
                this.noResults = false;
                window.history.pushState({}, document.title, window.location.pathname);
            },
            openSearchBar: function openSearchBar() {
                this.showSearch = true;
                document.querySelector("body").classList.toggle("in-search");
            },
            afterEnter: function afterEnter() {
                this.$refs.query.focus();
            },
            doSearch: function doSearch() {
                window.location = "/search?q=".concat(this.query);
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
    // open dropdown if li active
    if (document.querySelector(".nav-aside")) {
        var activeLiElements = document.querySelectorAll(".nav-aside .main-level > li.active ul ul > li.active");
        activeLiElements.forEach(function(el) {
            el.parentElement.classList.add("show");
            el.parentElement.parentElement.classList.add("open");
        });
    }
    // dropdown for nav aside
    var navDropdown = document.querySelectorAll(".nav-dropdown");
    if (navDropdown) navDropdown.forEach(function(el) {
        el.addEventListener("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            el.nextElementSibling.classList.toggle("show");
            el.classList.toggle("open");
        });
    });
    // in page nav
    $716de60f7510b94a$var$setOverflowInPageNav();
    //observer for in page nav
    var observerOptions = {
        rootMargin: "-30% 0px -70% 0px"
    };
    var observer = new IntersectionObserver(observerCallback, observerOptions);
    function observerCallback(entries) {
        entries.forEach(function(entry) {
            var entryId = entry.target.dataset.linkSubNav.replace("section_", "");
            var entryElement = document.querySelector(".menuheader_".concat(entryId));
            if (entry.isIntersecting) entryElement === null || entryElement === void 0 ? void 0 : entryElement.classList.add("active");
            else entryElement === null || entryElement === void 0 ? void 0 : entryElement.classList.remove("active");
        });
    }
    var target = ".section-block";
    document.querySelectorAll(target).forEach(function(i) {
        if (i) observer.observe(i);
    });
    window.addEventListener("resize", function() {
        setTimeout(function() {
            $716de60f7510b94a$var$setOverflowInPageNav();
        }, 800);
    });
});
function $716de60f7510b94a$var$setOverflowInPageNav() {
    var inPageNavContainer = document.querySelector(".in-page-sub-nav");
    var inPageNavElement = document.querySelectorAll(".in-page-sub-nav ul li");
    var inPageDropdown = document.querySelector(".in-page-sub-nav-container .dropdown-menu");
    var widthOfInPageNavContainer = 0;
    var widthOfInPageNavElements = 0;
    var elementsNotInView = [];
    if (inPageNavContainer) {
        widthOfInPageNavContainer = inPageNavContainer.clientWidth;
        document.querySelector(".inPageElementLength").value = inPageNavElement.length;
        inPageNavElement.forEach(function(item) {
            var itemPos = window.direct.getPosition(item, inPageNavContainer);
            if (itemPos.x + item.clientWidth > widthOfInPageNavContainer - 70) elementsNotInView.push(item);
            widthOfInPageNavElements += item.clientWidth;
        });
        inPageDropdown.innerHTML = "";
        elementsNotInView.forEach(function(el) {
            var newEl = el.cloneNode(true);
            newEl.classList.remove("nav-item");
            newEl.classList.add("dropdown-item");
            inPageDropdown.appendChild(newEl);
        });
        if (widthOfInPageNavElements > widthOfInPageNavContainer) {
            document.querySelector(".in-page-sub-nav ul.nav").classList.add("show");
            document.querySelector(".overflown-toggle").classList.add("show");
        } else {
            document.querySelector(".in-page-sub-nav ul.nav").classList.remove("show");
            document.querySelector(".overflown-toggle").classList.remove("show");
        }
    }
}


function $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f330ac5f61e1368d$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $f4bb2077aa61b74c$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $f500ece5c74d6d3d$var$extendStatics = function extendStatics1(d, b) {
    $f500ece5c74d6d3d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f500ece5c74d6d3d$var$extendStatics(d, b);
};
function $f500ece5c74d6d3d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f500ece5c74d6d3d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f500ece5c74d6d3d$export$18ce0697a983be9b = function __assign1() {
    $f500ece5c74d6d3d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f500ece5c74d6d3d$export$18ce0697a983be9b.apply(this, arguments);
};
function $f500ece5c74d6d3d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f500ece5c74d6d3d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f500ece5c74d6d3d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f500ece5c74d6d3d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f500ece5c74d6d3d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $f500ece5c74d6d3d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f500ece5c74d6d3d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f500ece5c74d6d3d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f500ece5c74d6d3d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f500ece5c74d6d3d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f500ece5c74d6d3d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f500ece5c74d6d3d$export$45d3717a4c69092e(o, m, p);
}
function $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f500ece5c74d6d3d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f500ece5c74d6d3d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f500ece5c74d6d3d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f500ece5c74d6d3d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f500ece5c74d6d3d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f500ece5c74d6d3d$export$10c90e4f7922046c(v) {
    return this instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? (this.v = v, this) : new $f500ece5c74d6d3d$export$10c90e4f7922046c(v);
}
function $f500ece5c74d6d3d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f500ece5c74d6d3d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f500ece5c74d6d3d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f500ece5c74d6d3d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f500ece5c74d6d3d$export$19a8beecd37a4c45 === "function" ? $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f500ece5c74d6d3d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f500ece5c74d6d3d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $f500ece5c74d6d3d$var$ownKeys = function ownKeys1(o) {
    $f500ece5c74d6d3d$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $f500ece5c74d6d3d$var$ownKeys(o);
};
function $f500ece5c74d6d3d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $f500ece5c74d6d3d$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $f500ece5c74d6d3d$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $f500ece5c74d6d3d$var$__setModuleDefault(result, mod);
    return result;
}
function $f500ece5c74d6d3d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f500ece5c74d6d3d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f500ece5c74d6d3d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f500ece5c74d6d3d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f500ece5c74d6d3d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $f4bb2077aa61b74c$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f500ece5c74d6d3d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f500ece5c74d6d3d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f500ece5c74d6d3d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $f500ece5c74d6d3d$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $f500ece5c74d6d3d$export$2e2bcd8739ae039 = {
    __extends: $f500ece5c74d6d3d$export$a8ba968b8961cb8a,
    __assign: $f500ece5c74d6d3d$export$18ce0697a983be9b,
    __rest: $f500ece5c74d6d3d$export$3c9a16f847548506,
    __decorate: $f500ece5c74d6d3d$export$29e00dfd3077644b,
    __param: $f500ece5c74d6d3d$export$d5ad3fd78186038f,
    __esDecorate: $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0,
    __runInitializers: $f500ece5c74d6d3d$export$d831c04e792af3d,
    __propKey: $f500ece5c74d6d3d$export$6a2a36740a146cb8,
    __setFunctionName: $f500ece5c74d6d3d$export$d1a06452d3489bc7,
    __metadata: $f500ece5c74d6d3d$export$f1db080c865becb9,
    __awaiter: $f500ece5c74d6d3d$export$1050f835b63b671e,
    __generator: $f500ece5c74d6d3d$export$67ebef60e6f28a6,
    __createBinding: $f500ece5c74d6d3d$export$45d3717a4c69092e,
    __exportStar: $f500ece5c74d6d3d$export$f33643c0debef087,
    __values: $f500ece5c74d6d3d$export$19a8beecd37a4c45,
    __read: $f500ece5c74d6d3d$export$8d051b38c9118094,
    __spread: $f500ece5c74d6d3d$export$afc72e2116322959,
    __spreadArrays: $f500ece5c74d6d3d$export$6388937ca91ccae8,
    __spreadArray: $f500ece5c74d6d3d$export$1216008129fb82ed,
    __await: $f500ece5c74d6d3d$export$10c90e4f7922046c,
    __asyncGenerator: $f500ece5c74d6d3d$export$e427f37a30a4de9b,
    __asyncDelegator: $f500ece5c74d6d3d$export$bbd80228419bb833,
    __asyncValues: $f500ece5c74d6d3d$export$e3b29a3d6162315f,
    __makeTemplateObject: $f500ece5c74d6d3d$export$4fb47efe1390b86f,
    __importStar: $f500ece5c74d6d3d$export$c21735bcef00d192,
    __importDefault: $f500ece5c74d6d3d$export$da59b14a69baef04,
    __classPrivateFieldGet: $f500ece5c74d6d3d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f500ece5c74d6d3d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f500ece5c74d6d3d$export$81fdc39f203e4e04,
    __addDisposableResource: $f500ece5c74d6d3d$export$88ac25d8e944e405,
    __disposeResources: $f500ece5c74d6d3d$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $f500ece5c74d6d3d$export$889dfb5d17574b0b
};


document.addEventListener("DOMContentLoaded", function() {
    var codeNotFormatted = document.querySelectorAll("pre:not(.formatted)");
    codeNotFormatted.forEach(function(c, index) {
        var container = document.createElement("div");
        container.wrapAll(c);
        if (container.querySelector("code")) {
            container.classList.add("snippet-container");
            var targetId = "after-code-".concat(index + 1);
            var copyButton = document.createElement("a");
            copyButton.className = "copy-to-clipboard-button-not-formatted btn btn-copy-not-formatted";
            copyButton.textContent = "Copy";
            var skipLink = document.createElement("a");
            skipLink.href = "#".concat(targetId);
            skipLink.className = "skip-content sr-only sr-only-focusable";
            skipLink.textContent = "Skip code example";
            container.prepend(copyButton);
            container.prepend(skipLink);
            var copyContent = document.createElement("div");
            copyContent.className = "copy-content";
            copyContent.style.display = "none";
            container.append(copyContent);
            container.querySelector("code").classList.add("code-snippet");
            var targetSpan = document.createElement("span");
            targetSpan.id = targetId;
            targetSpan.tabIndex = -1;
            container.append(targetSpan);
            var copyDiv = container.querySelector(".copy-content");
            var btn = container.querySelector(".copy-to-clipboard-button-not-formatted");
            var codeEl = container.querySelector("code").cloneNode(true);
            codeEl.querySelectorAll("br").forEach(function(br) {
                br.replaceWith(document.createTextNode("\r\n"));
            });
            copyDiv.value = $1e75e111dfe3eb37$var$unescapeHTML(codeEl.textContent);
            btn.addEventListener("click", function() {
                window.direct.selectText(container.querySelector(".code-snippet"));
                navigator.clipboard.writeText(copyDiv.value).then(function() {
                    btn.setAttribute("data-copy-state", "copy-success");
                    setTimeout(function() {
                        btn.removeAttribute("data-copy-state");
                    }, 2000);
                });
            });
        }
    });
    var allCodeSnippetContainers = document.querySelectorAll(".all-code-language-container");
    var codeComponents = {};
    allCodeSnippetContainers.forEach(function(container, idx) {
        codeComponents["vm-snippet-".concat(idx)] = new window.Vue({
            name: "code snippet-".concat(container.id),
            el: "#".concat(container.id),
            data: function() {
                return {
                    snippetUrl: "",
                    selectedLanguage: {},
                    canLinkToAPIExplorer: false,
                    loading: false,
                    languageOptions: {
                        backend: [
                            {
                                name: "Java",
                                value: "JAVA",
                                paramExplorer: "JAVA"
                            },
                            {
                                name: ".NET",
                                value: "DOTNET",
                                paramExplorer: "DOTNET"
                            },
                            {
                                name: "Node.js",
                                value: "JS",
                                paramExplorer: "JS"
                            },
                            {
                                name: "PHP",
                                value: "PHP",
                                paramExplorer: "PHP"
                            },
                            {
                                name: "Python",
                                value: "PYTHON",
                                paramExplorer: "PYTHON"
                            },
                            {
                                name: "Ruby",
                                value: "RUBY",
                                paramExplorer: "RUBY"
                            }
                        ]
                    }
                };
            },
            mounted: function() {
                var storedLanguage = sessionStorage.getItem("language");
                if (storedLanguage) this.selectedLanguage = JSON.parse(storedLanguage);
                else {
                    sessionStorage.setItem("language", JSON.stringify({
                        name: "Java",
                        value: "JAVA",
                        paramExplorer: "JAVA"
                    }));
                    this.selectedLanguage = {
                        name: "Java",
                        value: "JAVA",
                        paramExplorer: "JAVA"
                    };
                }
                if (document.querySelector("#".concat(container.id, " #tryitButton"))) {
                    this.canLinkToAPIExplorer = true;
                    this.getSnippets();
                }
            },
            methods: {
                getSnippets: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $f330ac5f61e1368d$export$71511d61b312f219)(function() {
                        var snippetUrl, codeEl, response, jsonData, error;
                        return (0, $f500ece5c74d6d3d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    this.loading = true;
                                    snippetUrl = "".concat(document.querySelector("#".concat(container.id, " #snippetUrl")).value, "?language=").concat(this.selectedLanguage.paramExplorer);
                                    codeEl = "#".concat(container.id, " .").concat(this.selectedLanguage.paramExplorer);
                                    this.snippetUrl = snippetUrl;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        5,
                                        6
                                    ]);
                                    return [
                                        4,
                                        fetch(snippetUrl)
                                    ];
                                case 2:
                                    response = _state.sent();
                                    if (!response.ok) // noinspection ExceptionCaughtLocallyJS
                                    throw new Error(response.status);
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 3:
                                    jsonData = _state.sent();
                                    document.querySelector(codeEl).innerHTML = jsonData.sampleBody;
                                    Prism.highlightElement(document.querySelector(codeEl));
                                    if (jsonData.apiExplorerParameters) document.querySelector("#".concat(container.id, " #tryitButton")).href = "".concat(document.querySelector("#".concat(container.id, " #tryitUrl")).value).concat(jsonData.apiExplorerParameters);
                                    else document.querySelector("#".concat(container.id, " #tryitButton")).style.display = "none";
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    error = _state.sent();
                                    console.error("There was an error!", error);
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    this.loading = false;
                                    return [
                                        7
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(this);
                },
                setLanguage: function(langItem) {
                    Object.entries(codeComponents).forEach(function(codeInstance) {
                        codeInstance[1].selectedLanguage = langItem;
                        if (codeInstance[1].snippetUrl) codeInstance[1].getSnippets();
                    });
                    sessionStorage.setItem("language", JSON.stringify(langItem));
                    if (document.querySelector(".language-nav")) $1e75e111dfe3eb37$var$setLanguageNav(langItem.value);
                },
                copy: function(activeCodeSnippet) {
                    var _this = this;
                    var code = "code-".concat(activeCodeSnippet.value);
                    var textA = this.$refs[activeCodeSnippet.value];
                    textA.value = $1e75e111dfe3eb37$var$unescapeHTML(this.$refs[code].innerHTML.replace(/<\/?[^>]+(>|$)/g, ""));
                    window.direct.selectText(this.$refs[code]);
                    navigator.clipboard.writeText(this.$refs[activeCodeSnippet.value].value).then(function() {
                        _this.$refs.copy.setAttribute("data-copy-state", "copy-success");
                        setTimeout(function() {
                            textA.value = null;
                            _this.$refs.copy.removeAttribute("data-copy-state");
                            window.getSelection().removeAllRanges();
                        }, 2000);
                    });
                }
            }
        });
        window.direct.setGlobalLanguage = setGlobalLanguage;
        function setGlobalLanguage(language) {
            Object.entries(codeComponents).forEach(function(codeInstance) {
                codeInstance[1].setLanguage(language);
            });
            if (document.querySelector(".language-nav")) $1e75e111dfe3eb37$var$setLanguageNav(language);
        }
        if (document.querySelector(".language-nav")) $1e75e111dfe3eb37$var$setLanguageNav();
    });
});
function $1e75e111dfe3eb37$var$unescapeHTML(v) {
    return v.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");
}
function $1e75e111dfe3eb37$var$setLanguageNav() {
    var selectedLanguage = JSON.parse(sessionStorage.getItem("language"));
    if (selectedLanguage) document.querySelectorAll(".language-nav a").forEach(function(item) {
        item.classList.remove("active");
        if (item.classList.contains("language-nav-".concat(selectedLanguage.value))) item.classList.add("active");
    });
}
var $1e75e111dfe3eb37$var$OFFSET = 60;
var $1e75e111dfe3eb37$var$skipLinks = document.querySelectorAll(".skip-content");
$1e75e111dfe3eb37$var$skipLinks.forEach(function(skipLink) {
    skipLink.addEventListener("click", function(e) {
        e.preventDefault();
        var targetId = skipLink.getAttribute("href").substring(1);
        var target = document.getElementById(targetId);
        if (!target) return;
        target.focus({
            preventScroll: true
        });
        var bodyRect = document.body.getBoundingClientRect().top;
        var elementRect = target.getBoundingClientRect().top;
        var offsetPosition = elementRect - bodyRect - $1e75e111dfe3eb37$var$OFFSET;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var allTablesOnPage = document.querySelectorAll("table:not(.payment-products, .action-table)");
    if (allTablesOnPage.length > 0) allTablesOnPage.forEach(function(t) {
        t.classList.add("table");
        var trs = document.querySelectorAll("tr");
        var tds = document.querySelectorAll("td");
        trs.forEach(function(row) {
            row.removeAttribute("style");
        });
        tds.forEach(function(cell) {
            cell.removeAttribute("style");
        });
        $20fb99d47cfa9b70$var$wrap(t, document.createElement("div"));
    });
});
function $20fb99d47cfa9b70$var$wrap(el, wrapper) {
    wrapper.classList.add("table-responsive");
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
}
function $20fb99d47cfa9b70$var$addTableScopeAttributes() {
    var tables = document.querySelectorAll('table');
    tables.forEach(function(table) {
        var thElements = table.querySelectorAll('th');
        thElements.forEach(function(th) {
            if (th.hasAttribute('scope')) return;
            var parent = th.parentElement;
            var parentTagName = parent.tagName.toLowerCase();
            if (parentTagName === 'thead' || $20fb99d47cfa9b70$var$isInFirstRow(th, table)) th.setAttribute('scope', 'col');
            else if ($20fb99d47cfa9b70$var$isFirstCellInRow(th)) th.setAttribute('scope', 'row');
            else {
                var cellIndex = Array.from(parent.children).indexOf(th);
                var rowIndex = Array.from(table.querySelectorAll('tr')).indexOf(parent);
                if (cellIndex === 0) th.setAttribute('scope', 'row');
                else if (rowIndex === 0) th.setAttribute('scope', 'col');
                else th.setAttribute('scope', 'col');
            }
        });
    });
}
function $20fb99d47cfa9b70$var$isInFirstRow(th, table) {
    var firstRow = table.querySelector('tr');
    return firstRow && firstRow.contains(th);
}
function $20fb99d47cfa9b70$var$isFirstCellInRow(th) {
    var row = th.parentElement;
    return row.children[0] === th;
}
document.addEventListener('DOMContentLoaded', $20fb99d47cfa9b70$var$addTableScopeAttributes);
function $20fb99d47cfa9b70$var$runAfterWYSIWYGLoad() {
    $20fb99d47cfa9b70$var$addTableScopeAttributes();
}
var $20fb99d47cfa9b70$var$observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'TABLE' || node.querySelectorAll('table').length > 0) setTimeout($20fb99d47cfa9b70$var$addTableScopeAttributes, 100); // Small delay to ensure DOM is ready
            }
        });
    });
});
$20fb99d47cfa9b70$var$observer.observe(document.body, {
    childList: true,
    subtree: true
});
window.fixTableScopes = $20fb99d47cfa9b70$var$addTableScopeAttributes;


function $09e2f1f84ceddf09$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $1e5b70c2c2307a84$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $09e2f1f84ceddf09$export$71511d61b312f219)(arr);
}


function $9b1241b318447a2a$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $e0c9573dc9b3384a$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $0ee6bdd820e270f4$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $09e2f1f84ceddf09$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $09e2f1f84ceddf09$export$71511d61b312f219)(o, minLen);
}


function $8d1416c8f734345e$export$71511d61b312f219(arr) {
    return (0, $1e5b70c2c2307a84$export$71511d61b312f219)(arr) || (0, $9b1241b318447a2a$export$71511d61b312f219)(arr) || (0, $0ee6bdd820e270f4$export$71511d61b312f219)(arr) || (0, $e0c9573dc9b3384a$export$71511d61b312f219)();
}


document.addEventListener("DOMContentLoaded", function() {
    var popoverTriggerList = document.querySelectorAll("[data-bs-toggle=\"popover\"]");
    var popoverList = (0, $8d1416c8f734345e$export$71511d61b312f219)(popoverTriggerList).map(function(popoverTriggerEl) {
        return new window.bootstrap.Popover(popoverTriggerEl);
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var video = document.querySelector("#homepage-video");
    if (video) {
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            var source = document.querySelector("#homepage-video");
            source.setAttribute("src", "/global/images/homepage_video-hevc-safari.mp4");
            source.setAttribute("type", "video/mp4");
            source.setAttribute("codecs", "hevc");
        }
        video.addEventListener("ended", function() {
            video.currentTime = 4.000;
            video.play();
        });
    }
});


document.addEventListener("DOMContentLoaded", function() {
    var thumbsUpBtn = document.querySelector("button.up");
    var thumbsDownBtn = document.querySelector("button.down");
    var thumbsSendBtn = document.querySelector("button.send");
    var messageContainer = document.querySelector(".thumbs-message-container");
    var buttonContainer = document.querySelector(".thumbs-button-container");
    var thumbValue = document.querySelector(".thumb-input");
    var pageValue = document.querySelector(".page-input");
    if (thumbsUpBtn) {
        thumbsUpBtn.addEventListener("click", function() {
            thumbValue.value = "up";
            pageValue.value = window.location.pathname;
            messageContainer.classList.toggle("show");
            buttonContainer.classList.toggle("show");
            gtag("event", "_sendThumb", {
                "event_label": "thumbs",
                "value": "up"
            });
        });
        thumbsDownBtn.addEventListener("click", function() {
            thumbValue.value = "down";
            pageValue.value = window.location.pathname;
            messageContainer.classList.toggle("show");
            buttonContainer.classList.toggle("show");
            gtag("event", "_sendThumb", {
                "event_label": "thumbs",
                "value": "down"
            });
        });
        thumbsSendBtn.addEventListener("click", function(event) {
            event.preventDefault();
            $b831cb87f68dc885$var$sendThumb();
        });
    }
});
function $b831cb87f68dc885$var$sendThumb() {
    var messageContainer = document.querySelector(".thumbs-message-container");
    var responseContainer = document.querySelector(".thumbs-response-container");
    var form = document.querySelector("#thumbsForm");
    grecaptcha.ready(function() {
        grecaptcha.execute("6Lfa2P8UAAAAABC6DlDHvyzoW7xhzeCgb5zoPaY4", {
            action: "submit"
        }).then(function(token) {
            form.insertAdjacentHTML("afterbegin", '<input type="hidden" name="g-recaptcha-response" value="'.concat(token, '" />'));
            var formData = new FormData(form);
            var object = {};
            formData.forEach(function(value, key) {
                return object[key] = value;
            });
            var headers = new Headers({
                "Content-Type": "application/json"
            });
            var options = {
                method: "POST",
                headers: headers,
                body: JSON.stringify(object)
            };
            fetch(form.action, options).then(function(res) {
                return res.json();
            }).then(function(res) {
                if (res.success) {
                    responseContainer.classList.toggle("show");
                    messageContainer.classList.toggle("show");
                } else console.error(res.reason);
            });
            return false;
        });
    });
}


document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("path,rect,polygon,circle,line,text").forEach(function(e) {
        // replace the fill colors
        var fillColor = e.getAttribute("fill");
        var strokeColor = e.getAttribute("stroke");
        switch(true){
            case fillColor === "#4E4745" || strokeColor === "#4E4745":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-dark-gray)");
                break;
            case fillColor === "white" || strokeColor === "white":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-white)");
                break;
            case fillColor === "#006A7A" || strokeColor === "#006A7A":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-dark-green)");
                break;
            case fillColor === "#007B7C" || strokeColor === "#007B7C":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-dark-green)");
                break;
            case fillColor === "#E5F2F4" || strokeColor === "#E5F2F4":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-light-green-gray)");
                break;
            case fillColor === "#FDE6F1" || strokeColor === "#FDE6F1":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-light-red-gray)");
                break;
            case fillColor === "#D6006B" || strokeColor === "#D6006B":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-red)");
                break;
            case fillColor === "#008094" || strokeColor === "#008094":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-green)");
                break;
            case fillColor === "#E60073" || strokeColor === "#E60073":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-light-red)");
                break;
            case fillColor === "#9A9695" || strokeColor === "#9A9695":
                e.setAttribute(fillColor ? "fill" : "stroke", "var(--color-gray)");
                break;
            default:
                e.setAttribute(fillColor ? "fill" : "stroke", fillColor ? fillColor : strokeColor);
        }
    });
});



document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".show-more a").forEach(function(showMore) {
        showMore.addEventListener("click", function(e) {
            var parent = showMore.dataset.parent;
            showMoreItems(parent, e.target);
        });
    });
    function showMoreItems(parent, showMoreLink) {
        var hiddenItems = document.querySelectorAll("#".concat(parent, " .hidden-item"));
        var hiddenItemsArray = (0, $8d1416c8f734345e$export$71511d61b312f219)(hiddenItems);
        hiddenItemsArray.forEach(function(hiddenItem) {
            hiddenItem.style.display = "list-item";
        });
        showMoreLink.parentNode.style.display = "none";
    }
});


document.addEventListener("DOMContentLoaded", function() {
    window.AOS.init();
});


document.addEventListener("DOMContentLoaded", function() {
    var checkboxes = document.querySelectorAll(".custom-checkbox");
    if (!checkboxes.length) return;
    /** @type String[] */ var selectedIds = [];
    var checkedInputs = JSON.parse(sessionStorage.getItem("checkedInputs"));
    if (checkedInputs) {
        selectedIds = checkedInputs;
        selectedIds.forEach(function(selectedId) {
            document.querySelectorAll(".check_".concat(selectedId)).forEach(function(el) {
                el.classList.add("checked");
            });
        });
        checkboxes.forEach(function(checkbox) {
            var checkId = checkbox.querySelector("input").getAttribute("data-checkbox");
            selectedIds.includes(checkId) && (checkbox.querySelector("input").checked = true);
        });
    }
    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener("click", function() {
            var checkId = checkbox.querySelector("input").getAttribute("data-checkbox");
            document.querySelectorAll(".check_".concat(checkId)).forEach(function(o) {
                if (checkbox.querySelector("input").checked) {
                    o.classList.add("checked");
                    selectedIds.push(checkId);
                } else {
                    o.classList.remove("checked");
                    selectedIds = selectedIds.filter(function(e) {
                        return e !== checkId;
                    });
                }
            });
            sessionStorage.setItem("checkedInputs", JSON.stringify(selectedIds));
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var signupBtnHeader = document.querySelector("#signup-toggle-header");
    var signupBtnBody = document.querySelector("#signup-toggle-body");
    var signupCancel = document.querySelector(".btn-hide-form");
    var signupModal = document.querySelector("#signup-modal");
    var signupForm = document.querySelector("#signup-form");
    var createAccountBtn = document.querySelector(".step a[href=\"#step-1\"]");
    var toggleSignupForm = function(show) {
        signupBtnBody.style.display = show ? "none" : "inline-block";
        signupForm.classList.toggle("hide-signup", !show);
        signupForm.classList.toggle("show-signup", show);
    };
    if (createAccountBtn) {
        createAccountBtn.removeAttribute("href");
        createAccountBtn.addEventListener("click", function(event) {
            event.preventDefault();
            document.querySelector("#step-1").scrollIntoView();
            toggleSignupForm(true);
        });
    }
    signupCancel.addEventListener("click", function(event) {
        event.preventDefault();
        toggleSignupForm(false);
    });
    signupBtnBody === null || signupBtnBody === void 0 ? void 0 : signupBtnBody.addEventListener("click", function(event) {
        event.preventDefault();
        toggleSignupForm(true);
    });
    // Handle all "Sign Up" buttons
    var signupButtons = document.querySelectorAll(".signup-btn");
    signupButtons.forEach(function(btn) {
        btn.addEventListener("click", function(event) {
            event.preventDefault();
            var formId = btn.dataset.formId;
            var form = document.querySelector("#".concat(formId));
            var errorForm = document.querySelector("#".concat(formId, " .error-form"));
            var successForm = document.querySelector("#".concat(formId, " + .success-form"));
            var signupOverlay = document.querySelector("#".concat(formId, " .signup-overlay"));
            var submitBtn = document.querySelector("#".concat(formId, " #signup-btn"));
            var replaceMail = document.querySelector("#".concat(formId, " + .success-form #replace-mail"));
            var formControls = form.querySelectorAll(".form-control");
            signupOverlay.style.display = "block";
            if (!form.checkValidity()) {
                event.stopPropagation();
                submitBtn.style.display = "block";
                setTimeout(function() {
                    signupOverlay.style.display = "none";
                }, 500);
            } else {
                var data = new FormData(form);
                var signupData = {
                    accountInfo: {
                        isp: data.get("isp"),
                        firstName: data.get("firstName"),
                        lastName: data.get("lastName"),
                        companyName: data.get("companyName"),
                        emailAddress: data.get("emailAddress")
                    },
                    captcha: {
                        captchaInput: data.get("captchaInput"),
                        captchaText: data.get("captchaText"),
                        key: data.get("key")
                    }
                };
                fetch("/app/service/signup/create-account", {
                    method: "POST",
                    body: JSON.stringify(signupData)
                }).then(function(response) {
                    return response.json();
                }).then(function(res) {
                    // If there's an error (res.status = true means an error in this context)
                    if (res.status) {
                        window.direct.fetchAndUpdateCaptcha();
                        errorForm.innerHTML = res.detail;
                        errorForm.style.display = "block";
                        formControls.forEach(function(control) {
                            control.addEventListener("input", function() {
                                control.classList.remove("is-invalid");
                                errorForm.style.display = "none";
                            });
                        });
                    } else {
                        // On success
                        form.reset();
                        form.style.display = "none";
                        successForm.style.display = "block";
                        replaceMail.innerHTML = replaceMail.innerHTML.replace(/aaaaa/g, res.emailAddress);
                    }
                    setTimeout(function() {
                        signupOverlay.style.display = "none";
                    }, 500);
                });
            }
            form.classList.add("was-validated");
        });
    });
    // Refresh captcha
    var refreshCaptcha = document.querySelectorAll(".refresh-captcha");
    refreshCaptcha.forEach(function(btn) {
        btn.addEventListener("click", function(event) {
            event.preventDefault();
            window.direct.fetchAndUpdateCaptcha();
        });
    });
    // Fetch the first captcha on load
    window.direct.fetchAndUpdateCaptcha();
});


document.addEventListener("DOMContentLoaded", function() {
    var enhanceMobileNavLinks = function() {
        var mobileNavList = document.querySelector(".mobile-nav-list");
        if (!mobileNavList) return;
        mobileNavList.querySelectorAll("a:not(.nav-link)").forEach(function(link) {
            return link.classList.add("nav-link");
        });
    };
    enhanceMobileNavLinks();
    var navToggle = document.getElementById("mobile-nav-toggle");
    var navMenu = document.getElementById("mobile-nav-menu");
    var navOverlay = document.getElementById("mobile-nav-overlay");
    var closeButton = document.querySelector(".mobile-nav-close");
    var closeAllSubmenus = function() {
        navMenu.querySelectorAll('.submenu[aria-hidden="false"]').forEach(function(submenu) {
            return submenu.setAttribute("aria-hidden", "true");
        });
        navMenu.querySelectorAll('button[aria-expanded="true"]').forEach(function(btn) {
            return btn.setAttribute("aria-expanded", "false");
        });
    };
    var openMainNav = function() {
        navToggle.setAttribute("aria-expanded", "true");
        navMenu.setAttribute("aria-hidden", "false");
        document.body.classList.add("nav-open");
    };
    var closeMainNav = function() {
        navToggle.setAttribute("aria-expanded", "false");
        navMenu.setAttribute("aria-hidden", "true");
        document.body.classList.remove("nav-open");
        closeAllSubmenus();
    };
    if (navToggle) navToggle.addEventListener("click", function() {
        var isExpanded = navToggle.getAttribute("aria-expanded") === "true";
        isExpanded ? closeMainNav() : openMainNav();
    });
    if (closeButton) closeButton.addEventListener("click", closeMainNav);
    if (navOverlay) navOverlay.addEventListener("click", closeMainNav);
    document.addEventListener("keydown", function(e) {
        var isNavOpen = navToggle.getAttribute("aria-expanded") === "true";
        if (e.key === "Escape" && isNavOpen) closeMainNav();
    });
    navMenu.querySelectorAll(".submenu-toggle").forEach(function(toggle) {
        toggle.addEventListener("click", function(e) {
            e.stopPropagation();
            var submenuId = toggle.getAttribute("aria-controls");
            var submenu = document.getElementById(submenuId);
            if (!submenu) return;
            var parentUl = toggle.closest("ul");
            parentUl.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach(function(sib) {
                if (sib === toggle) return;
                var sibSubmenu = document.getElementById(sib.getAttribute("aria-controls"));
                sib.setAttribute("aria-expanded", "false");
                if (sibSubmenu) sibSubmenu.setAttribute("aria-hidden", "true");
            });
            var isExpanded = toggle.getAttribute("aria-expanded") === "true";
            toggle.setAttribute("aria-expanded", isExpanded ? "false" : "true");
            submenu.setAttribute("aria-hidden", isExpanded ? "true" : "false");
        });
    });
    navMenu.querySelectorAll(".back-button").forEach(function(button) {
        button.addEventListener("click", function(e) {
            e.stopPropagation();
            var submenu = button.closest(".submenu");
            if (!submenu) return;
            var toggle = document.querySelector('[aria-controls="'.concat(submenu.id, '"]'));
            if (toggle) {
                toggle.setAttribute("aria-expanded", "false");
                submenu.setAttribute("aria-hidden", "true");
            }
        });
    });
    var siteSwitchButton = document.getElementById("site-switch-button");
    var siteSwitchDropdown = document.getElementById("site-switch-dropdown");
    var _siteSwitchDropdown_querySelector;
    var siteSwitcherClose = (_siteSwitchDropdown_querySelector = siteSwitchDropdown === null || siteSwitchDropdown === void 0 ? void 0 : siteSwitchDropdown.querySelector(".dropdown-close")) !== null && _siteSwitchDropdown_querySelector !== void 0 ? _siteSwitchDropdown_querySelector : null;
    if (siteSwitchButton && siteSwitchDropdown) {
        siteSwitchButton.addEventListener("click", function(e) {
            e.stopPropagation();
            var isOpen = siteSwitchDropdown.classList.contains("show");
            siteSwitchDropdown.classList.toggle("show", !isOpen);
            siteSwitchButton.setAttribute("aria-expanded", isOpen ? "false" : "true");
        });
        if (siteSwitcherClose) siteSwitcherClose.addEventListener("click", function(e) {
            e.stopPropagation();
            siteSwitchDropdown.classList.remove("show");
            siteSwitchButton.setAttribute("aria-expanded", "false");
        });
        document.addEventListener("click", function(e) {
            var isClickInside = siteSwitchButton.contains(e.target) || siteSwitchDropdown.contains(e.target);
            if (!isClickInside) {
                siteSwitchDropdown.classList.remove("show");
                siteSwitchButton.setAttribute("aria-expanded", "false");
            }
        });
    }
});


var $60866ef6638f67eb$export$402e93b99ecebdf7 = {
    play: '        <svg\n            fill="currentColor"\n            width="100%"\n            height="100%"\n            viewBox="0 0 2889 2889"\n            xmlns="http://www.w3.org/2000/svg"\n            xml:space="preserve"\n            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"\n        >\n            <path d="M2039.39,1398.46l-1047.07,-604.535c-43.446,-25.087 -79.015,-4.558 -79.015,45.616l-0,1209.03c-0,50.195 35.569,70.725 79.015,45.616l1047.07,-604.514c43.446,-25.108 43.446,-66.146 0,-91.254l0,0.043Z" />\n            <g>\n                <clipPath id="_clip1">\n                    <rect x="-0.043" y="0" width="2887.5" height="2887.5" />\n                </clipPath>\n                <g clip-path="url(#_clip1)">\n                    <path\n                        d="M2774.63,881.944c-72.721,-171.961 -176.845,-326.41 -309.44,-459.006c-132.596,-132.595 -287.044,-236.718 -459.006,-309.44c-178.06,-75.325 -367.209,-113.498 -562.109,-113.498c-194.922,-0 -384.05,38.173 -562.132,113.498c-171.961,72.743 -326.41,176.845 -459.006,309.44c-132.595,132.618 -236.718,287.045 -309.44,459.006c-75.325,178.082 -113.498,367.21 -113.498,562.132c0,194.9 38.173,384.049 113.498,562.109c72.743,171.983 176.845,326.41 309.44,459.006c132.618,132.617 287.045,236.719 459.006,309.44c178.082,75.326 367.21,113.52 562.132,113.52c194.9,0 384.049,-38.194 562.109,-113.52c171.983,-72.721 326.41,-176.845 459.006,-309.44c132.617,-132.596 236.719,-287.044 309.44,-459.006c75.326,-178.06 113.52,-367.209 113.52,-562.109c0,-194.922 -38.194,-384.05 -113.52,-562.132Zm-1330.58,1889.26c-731.771,0 -1327.15,-595.334 -1327.15,-1327.13c0,-731.793 595.356,-1327.15 1327.15,-1327.15c731.792,0 1327.13,595.356 1327.13,1327.15c-0,731.792 -595.335,1327.13 -1327.13,1327.13Z"\n                        fill="currentColor"\n                    />\n                </g>\n            </g>\n        </svg>',
    pause: '<svg\n            fill="currentColor"\n            width="100%"\n            height="100%"\n            viewBox="0 0 2901 2901"\n            xmlns="http://www.w3.org/2000/svg"\n            xml:space="preserve"\n            style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"\n        >\n            <g>\n                <clipPath id="_clip1">\n                    <rect x="-0" y="-0" width="2900" height="2900" />\n                </clipPath>\n                <g clip-path="url(#_clip1)">\n                    <path d="M1450.04,-0c-801.237,-0 -1450.04,653.168 -1450.04,1450.02c-0,801.237 653.168,1450.04 1450.04,1450.04c801.216,0 1450.02,-653.168 1450.02,-1450.04c0,-801.216 -648.806,-1450.02 -1450.02,-1450.02Zm0,2769.42c-727.191,-0 -1319.4,-592.188 -1319.4,-1319.4c0,-727.192 592.21,-1319.38 1319.4,-1319.38c727.192,0 1319.4,592.188 1319.4,1319.38c0,727.192 -592.209,1319.4 -1319.4,1319.4Z" />\n                </g>\n            </g>\n            <path d="M1271.51,744.618l-195.963,0c-47.895,0 -87.088,39.171 -87.088,87.088l-0,1232.31c-0,47.895 39.193,87.088 87.088,87.088l195.963,-0c47.895,-0 87.088,-39.193 87.088,-87.088l-0,-1232.31c-0,-47.917 -39.193,-87.088 -87.088,-87.088Z" />\n            <path d="M1824.52,744.618l-195.964,0c-47.895,0 -87.088,39.171 -87.088,87.088l0,1232.31c0,47.895 39.193,87.088 87.088,87.088l195.964,-0c47.895,-0 87.087,-39.193 87.087,-87.088l0,-1232.31c0,-47.917 -39.192,-87.088 -87.087,-87.088Z" />\n        </svg>'
};
var $60866ef6638f67eb$export$2f81d122b505481c = [
    "playPause"
];


var $442e3ded65f0ea45$var$svgFromString = function(iconName) {
    var svgText = (0, $60866ef6638f67eb$export$402e93b99ecebdf7)[iconName];
    var doc = new DOMParser().parseFromString(svgText, "image/svg+xml");
    return document.importNode(doc.documentElement, true);
};
var $442e3ded65f0ea45$export$67d735d2a4bd3888 = {
    playPause: function(param) {
        var button = param.button, synth = param.synth, utterance = param.utterance, state = param.state, text = param.text;
        var icon = $442e3ded65f0ea45$var$svgFromString("play");
        button.appendChild(icon);
        var updateIcon = function() {
            var next = state.isPlaying && !state.isPaused ? "pause" : "play";
            var newSvg = $442e3ded65f0ea45$var$svgFromString(next);
            button.replaceChildren(newSvg);
        };
        utterance.addEventListener("end", function() {
            state.isPlaying = false;
            state.isPaused = false;
            updateIcon();
        });
        utterance.addEventListener("error", function() {
            state.isPlaying = false;
            state.isPaused = false;
            updateIcon();
        });
        updateIcon();
        button.addEventListener("click", function() {
            if (!text) return;
            if (!state.isPlaying && !state.isPaused) {
                synth.cancel();
                synth.speak(utterance);
                state.isPlaying = true;
                state.isPaused = false;
            } else if (state.isPlaying && !state.isPaused) {
                synth.pause();
                state.isPaused = true;
            } else {
                synth.resume();
                state.isPaused = false;
            }
            updateIcon();
        });
    }
};


/**
 * @param {HTMLElement} containerElement - Container to append into.
 * @returns {HTMLDivElement | null}
 */ var $4581adf747977dfc$var$createTextToSpeechContainer = function(containerElement) {
    if (!containerElement) return null;
    var textToSpeechContainer = document.createElement("div");
    textToSpeechContainer.className = "wl-speech-player-container";
    containerElement.appendChild(textToSpeechContainer);
    return textToSpeechContainer;
};
/**
 * Create one button per option.
 *
 * @param {string[]} options - List of option names, e.g. ["playPause"].
 * @param {SpeechSynthesis} synth - Web Speech synthesis instance.
 * @param {SpeechSynthesisUtterance} utterance - Utterance to control.
 * @param {{isPlaying: boolean, isPaused: boolean}} state - Shared player state.
 * @param {string} text - Text to speech.
 * @param {Translations} translations
 * @returns {HTMLButtonElement[]} - Array of created buttons.
 */ var $4581adf747977dfc$var$createButtons = function(options, synth, utterance, state, text, translations) {
    /** @type {HTMLButtonElement[]} */ var buttons = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var controlDefinition = (0, $442e3ded65f0ea45$export$67d735d2a4bd3888)[name];
            if (!controlDefinition) {
                console.warn("".concat(translations.unsupported_option_ignored, ' "').concat(name, '"'));
                continue;
            }
            var button = document.createElement("button");
            button.type = "button";
            button.className = "wl-speech-player-button";
            button.ariaLabel = name;
            button.dataset.control = name;
            controlDefinition({
                button: button,
                synth: synth,
                utterance: utterance,
                state: state,
                text: text
            });
            buttons.push(button);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return buttons;
};
/**
 * Prepares the button container and creates buttons
 *
 * @param {string[]} options - List of option names, e.g. ["playPause"].
 * @param {SpeechSynthesis} synth - Web Speech synthesis instance.
 * @param {SpeechSynthesisUtterance} utterance - Utterance to control.
 * @param {{isPlaying: boolean, isPaused: boolean}} playerState - Shared player state.
 * @param {string} text - Text to be read.
 * @param {Translations} translations
 * @returns {HTMLDivElement}
 */ var $4581adf747977dfc$var$prepareButtonContainer = function(options, synth, utterance, playerState, text, translations) {
    var buttonContainer = document.createElement("div");
    buttonContainer.className = "wl-speech-player-button-container";
    var buttons = $4581adf747977dfc$var$createButtons(options, synth, utterance, playerState, text, translations);
    buttons.forEach(function(button) {
        buttonContainer.appendChild(button);
    });
    return buttonContainer;
};
var $4581adf747977dfc$export$ef0f7f494eea8d31 = function(rootElement, containerElement) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        "playPause"
    ], translations = arguments.length > 3 ? arguments[3] : void 0;
    var textToSpeechContainer = $4581adf747977dfc$var$createTextToSpeechContainer(containerElement);
    if (!textToSpeechContainer) {
        console.error(translations.no_container_element_provided);
        return null;
    }
    var text = (rootElement.innerText || "").trim();
    var synth = window.speechSynthesis;
    if (!synth) {
        console.error(translations.web_speech_api_not_supported);
        return null;
    }
    var utterance = new SpeechSynthesisUtterance(text);
    var playerState = {
        isPlaying: false,
        isPaused: false
    };
    var buttonContainer = $4581adf747977dfc$var$prepareButtonContainer(options, synth, utterance, playerState, text, translations);
    var label = document.createElement("label");
    label.className = "wl-speech-player-label";
    label.textContent = translations.listen_to_this_page;
    textToSpeechContainer.appendChild(buttonContainer);
    textToSpeechContainer.appendChild(label);
    return synth;
};



function $28557b013f37bb6b$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $9bf4d105a019f48b$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $28557b013f37bb6b$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


var $5fbe5eb1c835a3ca$exports = {};
$5fbe5eb1c835a3ca$exports = JSON.parse('{"base":{"no_container_element_provided":"No containerElement provided.","no_container_selector_found":"No container selector found.","web_speech_api_not_supported":"Web Speech API not supported.","unsupported_option_ignored":"Unsupported option ignored:"},"en":{"listen_to_this_page":"Listen to this page"},"fr":{"listen_to_this_page":"\xc9coutez cette page"},"de":{"listen_to_this_page":"Diese Seite anh\xf6ren"}}');


function $7e92cab0f0ddb43d$export$a7e3aedd9ea505f2() {
    var lang = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en";
    var selected = (0, (/*@__PURE__*/$parcel$interopDefault($5fbe5eb1c835a3ca$exports)))[lang] || (0, (/*@__PURE__*/$parcel$interopDefault($5fbe5eb1c835a3ca$exports))).en;
    return /** @type {Translations} */ (0, $9bf4d105a019f48b$export$71511d61b312f219)({}, (0, (/*@__PURE__*/$parcel$interopDefault($5fbe5eb1c835a3ca$exports))).base, selected);
}


var $1e3c9e1087946851$var$synth;
document.addEventListener("DOMContentLoaded", function() {
    var scriptTag = document.currentScript || document.querySelector("script[container-selector]");
    if (!scriptTag) return;
    var rootSelector = scriptTag.getAttribute("root-selector");
    var containerSelector = scriptTag.getAttribute("container-selector");
    var language = scriptTag.getAttribute("language") || "en";
    var translations = (0, $7e92cab0f0ddb43d$export$a7e3aedd9ea505f2)(language);
    if (!containerSelector) {
        console.error(translations.no_container_selector_found);
        return;
    }
    var root = rootSelector ? document.querySelector(rootSelector) : document.body;
    var containerElement = document.querySelector(containerSelector);
    $1e3c9e1087946851$var$synth = (0, $4581adf747977dfc$export$ef0f7f494eea8d31)(root, containerElement, (0, $60866ef6638f67eb$export$2f81d122b505481c), translations);
});
window.addEventListener("beforeunload", function() {
    $1e3c9e1087946851$var$synth === null || $1e3c9e1087946851$var$synth === void 0 ? void 0 : $1e3c9e1087946851$var$synth.cancel();
});
window.addEventListener("pagehide", function() {
    $1e3c9e1087946851$var$synth === null || $1e3c9e1087946851$var$synth === void 0 ? void 0 : $1e3c9e1087946851$var$synth.cancel();
});


if (!window.direct) window.direct = {};

})();
//# sourceMappingURL=default.js.map
